import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { triageEnabled } from './triage/enabled';

ReactDOM.render(<App />, document.getElementById('root'));

if (triageEnabled()) {
  void import('./triage/triage').then((m) => m.initTriage());
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
